import * as React from "react";
import FormControl from "@mui/joy/FormControl";
import FormLabel from "@mui/joy/FormLabel";
import Input from "@mui/joy/Input";
import Stack from "@mui/joy/Stack";
import CardActions from "@mui/joy/CardActions";
import CardOverflow from "@mui/joy/CardOverflow";
import EmailRoundedIcon from "@mui/icons-material/EmailRounded";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
import { add } from "../../../service/clientService";
import { Button } from "primereact/button";
import DropdownApi from "../../../components/DropdownApi";
import { UserSession } from "../../../models/UserSession";
import AssignmentRoundedIcon from "@mui/icons-material/AssignmentRounded";
import { addEmployee, updateEmployee } from "../../../service/employeeService";
import { NprLookup } from "../../../service/api-service";
import S3ImagePreview from "../../../components/S3ImagePreview";
import { Avatar } from "primereact/avatar";
import { placeholder } from "../../../assets/placeholder";
import MultiDropdownApi from "../../../components/MultiDropdownApi";
import { siteEmployeeAdd, siteEmployeeUpdate, siteSubcontractorAdd } from "../../../service/siteService";
import { Grid } from "@mui/material";
import { useToast } from "../../../context/ToastContext";
import { SubContractor } from "../Create/Steps/SubContractor";

export default function SiteSubcontractorAdd(modalProps: any) {
  const record = modalProps.record;
  const toast = useToast();

  async function SubcontractorAdd() {
    let createObject: any = {
      subcontractors,
    };

    modalProps.setGlobalLoading(true);

    siteSubcontractorAdd(createObject).then((r: any) => {
      toast("success", "Subcontractor Added Successfully");
      modalProps.setReload?.(!modalProps.reload);
      modalProps.setVisible?.(false);
      modalProps.setGlobalLoading(false);
      if (modalProps.callback) modalProps.callback();
    }).catch((e: any) => {
      toast("error", "Error Adding Subcontractor");
      modalProps.setGlobalLoading(false);
    });
  }

  const [subcontractors, setSubcontractors] = React.useState<any[]>([]);

  const [formData, setFormData] = React.useState<any>({});

  function handleKeyValueChange(name: string, value: unknown) {
    setSubcontractors(value as any[]);
  }

  return (
    <React.Fragment>
      <SubContractor handleChange={handleKeyValueChange} formData={formData} />
      <CardOverflow
        style={{ width: "100%" }}
        sx={{ borderTop: "1px solid", borderColor: "divider" }}
      >
        <CardActions style={{ marginTop: 15 }} sx={{ alignSelf: "flex-end", pt: 2 }}>
          <Button
            type="button"
            icon="pi pi-save"
            label="Save"
            className="p-button-outlined"
            size="small"
            style={{ position: "absolute", fontSize: "small", right: 0, color: "#2dd36f" }}
            onClick={() => SubcontractorAdd()}
          />
        </CardActions>
      </CardOverflow>
    </React.Fragment>
  );
}
